import React from 'react';
import Layouts from 'components/Layouts';
import AccreditationBody from 'modules/accreditation-body';
import PageHeader from 'components/Pages/PageHeader';

function Index() {
  return (
    <Layouts header={false} footer>
      <PageHeader logoSize="lg" fluid={false} fixed={false} sticky />
      <AccreditationBody />
    </Layouts>
  );
}

export default Index;
